import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=15520bd8&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=15520bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15520bd8",
  null
  
)

export default component.exports